import type { FC } from 'react';
import React from 'react';
import { Spinner, useAsync, Text } from '@wix/cli-ui-kit';
import { useDevCenterClient } from '@wix/dev-center-client';
import { match } from 'variant';
import { useProjectModel } from '../../model.js';

export const AddPermissionCommand: FC<{
  permissionId: string;
}> = ({ permissionId }) => {
  const { model } = useProjectModel();
  const { addPermission } = useDevCenterClient();

  const { status } = useAsync(async () => {
    const data = await addPermission({
      appId: model.config.appId,
      permissionId,
    });

    return data;
  }, []);

  return match(status, {
    Loading: () => <Spinner />,
    Error: () => null,
    Success: () => <Text>{'Permission added successfully'}</Text>,
  });
};
